/* Delivery estimates follow the shipping policy: usually dispatched the same business day before cutoff; delivery usually 1-2 business days. Other cart enhancements below. */
(function () {
  'use strict';

  /* ---------- 1. Levertijd ---------- */
  var DAYS = ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'];
  var MONTHS = ['jan', 'feb', 'mrt', 'apr', 'mei', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'];

  function amsterdamNow() {
    // Tijd in Europe/Amsterdam als losse velden, onafhankelijk van de tijdzone van het toestel.
    var parts = {};
    new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Amsterdam', year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false
    }).formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; });
    var h = +parts.hour === 24 ? 0 : +parts.hour;
    return { y: +parts.year, m: +parts.month, d: +parts.day, h: h, min: +parts.minute, s: +parts.second };
  }
  function ymd(date) { // date = Date in UTC-middag van die kalenderdag
    var m = date.getUTCMonth() + 1, d = date.getUTCDate();
    return date.getUTCFullYear() + '-' + (m < 10 ? '0' : '') + m + '-' + (d < 10 ? '0' : '') + d;
  }
  function addDays(date, n) { var x = new Date(date.getTime()); x.setUTCDate(x.getUTCDate() + n); return x; }
  function isWorkday(date, closed) { var wd = date.getUTCDay(); return wd !== 0 && wd !== 6 && closed.indexOf(ymd(date)) === -1; }
  function nextWorkday(date, closed) { var x = addDays(date, 1); while (!isWorkday(x, closed)) x = addDays(x, 1); return x; }
  function label(date, today) {
    var diff = Math.round((date - today) / 86400000);
    var base = DAYS[date.getUTCDay()] + ' ' + date.getUTCDate() + ' ' + MONTHS[date.getUTCMonth()];
    if (diff === 0) return 'vandaag';
    if (diff === 1) return 'morgen (' + base + ')';
    return base;
  }

  function renderDelivery(el) {
    var cutoff = parseInt(el.getAttribute('data-cutoff'), 10) || 20;
    var closed = (el.getAttribute('data-closed') || '').split(',').filter(Boolean);
    var now = amsterdamNow();
    var today = new Date(Date.UTC(now.y, now.m - 1, now.d, 12));
    var shipToday = isWorkday(today, closed) && now.h < cutoff;
    var ship = shipToday ? today : nextWorkday(today, closed);
    var first;
    if (shipToday) {
      var left = (cutoff * 60) - (now.h * 60 + now.min);
      var hh = Math.floor(left / 60), mm = left % 60;
      var t = hh > 0 ? hh + ' u ' + mm + ' min' : mm + ' min';
      first = 'Bestel binnen <b>' + t + '</b>, dan verzenden we meestal vandaag.';
    } else {
      first = 'Verwachte verzending: <b>' + label(ship, today) + '</b>.';
    }
    var second = 'Bezorging meestal binnen 1–2 werkdagen. Je ontvangt track & trace.';
    el.innerHTML = '<span class="ux-delivery__main">' + first + '</span><span class="ux-delivery__sub">' + second + '</span>';
    el.classList.add('is-live');
    var host = el.closest('.sm-info');
    if (host) host.classList.add('ux-delivery-on');
  }
  function tick() { document.querySelectorAll('[data-ux-delivery]').forEach(renderDelivery); }
  if (window.Intl && Intl.DateTimeFormat && Intl.DateTimeFormat.prototype.formatToParts) {
    tick();
    setInterval(tick, 30000);
  }

  /* ---------- 2. Bundelkeuze: hele kaart aanklikbaar ---------- */
  if (document.documentElement.hasAttribute('data-ux-fbt')) {
    document.addEventListener('click', function (e) {
      var block = e.target.closest && e.target.closest('[id*="essential_upsell_frequently_bought_together"]');
      if (!block) return;
      if (e.target.closest('input, button, a, label, select')) return;
      var node = e.target;
      while (node && node !== block) {
        var boxes = node.querySelectorAll ? node.querySelectorAll('input[type="checkbox"]') : [];
        if (boxes.length === 1) {
          if (!boxes[0].disabled) boxes[0].click();
          return;
        }
        if (boxes.length > 1) return; // te hoog: meerdere kaarten
        node = node.parentElement;
      }
    });
  }

  /* ---------- 3. Winkelwagenlade: passend accessoire toevoegen ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-ux-pair-add]');
    if (!btn) return;
    e.preventDefault();
    btn.setAttribute('aria-busy', 'true');
    var drawer = document.querySelector('cart-drawer');
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: +btn.getAttribute('data-ux-pair-add'), quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname })
    }).then(function (r) { return r.json(); }).then(function (state) {
      if (state && state.sections && drawer && typeof drawer.renderContents === 'function') {
        drawer.renderContents(state);
      } else {
        window.location.href = '/cart';
      }
      try { (window.dataLayer = window.dataLayer || []).push({ event: 'cart_pair_add', variant_id: btn.getAttribute('data-ux-pair-add') }); } catch (err) {}
    }).catch(function () { btn.removeAttribute('aria-busy'); });
  });

  /* ---------- 4. Upsell-app in de lade (Essential Upsell): seizoensloze kop, geen producten die al in de wagen zitten ----------
     De app-titel "Zomerdeals: Extra bundelvoordeel" staat in de app-instellingen; tot die daar is aangepast zet het thema hem om.
     Herkenning via structuur (div zonder attributen direct in cart-drawer-items), niet via de gegenereerde classnamen. */
  var APP_TITLE = 'Vaak samen gekocht';
  function fixAppUpsell() {
    var holder = document.querySelector('cart-drawer-items');
    if (!holder) return;
    var inCart = [].map.call(holder.querySelectorAll('.cart-item__name'), function (a) { return (a.textContent || '').trim().toLowerCase(); }).filter(Boolean);
    [].forEach.call(holder.children, function (root) {
      if (root.tagName !== 'DIV' || root.attributes.length) return;
      var hits = [].filter.call(root.querySelectorAll('*'), function (el) { return /zomerdeal/i.test(el.textContent || ''); });
      var head = hits[hits.length - 1];
      if (head && head.textContent !== APP_TITLE) head.textContent = APP_TITLE;
      [].forEach.call(root.querySelectorAll('button'), function (btn) {
        var row = btn.parentElement;
        while (row && row !== root && (row.textContent || '').indexOf('€') === -1) row = row.parentElement;
        if (!row || row === root) return;
        var txt = (row.textContent || '').toLowerCase();
        if (inCart.some(function (t) { return t && txt.indexOf(t) !== -1; })) row.style.display = 'none';
      });
    });
  }
  var uxBusy = false;
  var uxObs = new MutationObserver(function () { if (uxBusy) return; uxBusy = true; requestAnimationFrame(function () { fixAppUpsell(); uxBusy = false; }); });
  function startObs() { var cd = document.querySelector('cart-drawer'); if (cd) { uxObs.observe(cd, { childList: true, subtree: true }); fixAppUpsell(); } }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', startObs); else startObs();
})();
